import React, { useEffect } from 'react';
import { observer, useLocalStore } from 'mobx-react-lite';
import { autorun } from 'mobx';
import { Tab, Tabs } from '@material-ui/core';
import { useStores } from '../../_stores';
import Secure from './Components/InfoSecure';
import TableLicense from './Components/TableLicense';

const Dictionaries = observer(() => {
    const {secureStore} = useStores();

    const state = useLocalStore(() => ({
        currentTab: 0,
    }));
    
    useEffect(() => {
        autorun(async () => {
            await secureStore.loadSecureInfo();
        });
    }, []);

    return (
        <div>
            <Tabs
                value={state.currentTab}
                onChange={async (event, newValue) => {
                    state.currentTab = newValue;
                }}
            >
                <Tab key={0} label={"Таблица лицензий"} />
                <Tab key={1} label={"Информация о лицензии"} />
                
            </Tabs>
            {state.currentTab === 1 && <Secure/>}
            {state.currentTab === 0 && <TableLicense/>}
        </div>
    );
});

export default Dictionaries;